/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Cognos Analytics Home (C) Copyright IBM Corp. 2020, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'./NavigatorDialog',
	'react',
	'react-dom'
], function(NavigatorDialog, React, ReactDOM) {

	class CopyMoveDialog extends NavigatorDialog {

		constructor(options) {
			super(options);
			this.ManageContentDialogView = options.ManageContentDialogView;
			this.viewOptions = options.viewOptions;
		}

		open() {
			this.isOpen = true;
			return this.render();
		}

		remove() {
			this.isOpen = false;
			const mountPoint = document.getElementById('copyMoveDialog');
			ReactDOM.unmountComponentAtNode(mountPoint);
			mountPoint.parentNode.removeChild(mountPoint);
		}

		render() {
			return this._getFolderData().then((folderInfo) => {
				const options = {
					glassContext: this.glassContext,
					isOpen: true,
					closeDialog: this.remove.bind(this),
					ManageContentDialogView: this.ManageContentDialogView,
					viewOptions: this.viewOptions,
					selectedTabId: folderInfo.tab,
					pathRef: folderInfo.folder
				};
	
				let mountPoint = document.createElement('div');
				mountPoint.setAttribute('id', 'copyMoveDialog');
				document.body.appendChild(mountPoint);
	
				return new Promise((resolve, reject) => {
					require(['ca-content/home/caHome'], (caHome) => {
						ReactDOM.render(React.createElement(caHome.CopyMoveDialog, options), mountPoint);
						resolve();
					}, reject);
				});
			});
		}
	}
	return CopyMoveDialog;
});
